import React, {useEffect} from 'react'
import StatisticsService from "services/StatisticsService";
import Workspace from "components/Workspace";
import CtrCorrespondenceSection from "./sections/CtrCorrespondenceSection";

function CtrCorrespondencePanel(
    {
        match
    }) {

    const demandId = match.params.id;

    useEffect(() => {
        StatisticsService.getCurrentRound(demandId);
        return () => {
            StatisticsService.clearCurrentRound();
        }
        // eslint-disable-next-line
    }, []);


    return (
        <>
            <Workspace
                render={<>
                    <CtrCorrespondenceSection />
                </>}
            />
        </>
    )
}


export default CtrCorrespondencePanel;